module.exports = __webpack_public_path__ + "static/media/masonry-color.f8ee628e.svg";